import { createMuiTheme } from '@material-ui/core/styles';

export const muiThemeNext = createMuiTheme({
  palette: {
    primary: {
      main: '#0C53B0',
    },
  },
  typography: {
    fontColor: '#2A323C',
    fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '28px',
    },
    h2: {
      fontSize: '24px',
    },
    h3: {
      fontSize: '22px',
    },
    h4: {
      fontSize: '18px',
    },
    h5: {
      fontSize: '16px',
    },
    h6: {
      color: '#2A323C',
      fontSize: '14px',
      fontWeight: 600,
    },
    body1: {
      fontSize: '12px',
      color: '#2A323C',
    },
    body2: {
      fontSize: '12px',
    },
    body3: {
      fontSize: '12px',
      lineHeight: '30px',
    },
    // button: {
    //   backgroundColor: '#1871E8',
    //   fontColor: '#FFFFFF',
    //   color:  '#FFFFFF',
    //   fontWeight: 400,
    // },
    // button1: {
    //   backgroundColor: '#1871E8',
    //   color: '#FFFFF',
    //   fontWeight: 400,
    // },
  },
});



// WEBPACK FOOTER //
// ./src/client/material-ui-theme.js